import { Colors } from '@blueprintjs/core';

const colorPalette = {
  ...Colors,
  DARK_GREEN: '#1D7324',
  LIGHT_GREEN: '#8BAE44',
  KHAKI: '#FFE39F',
  SEA: '#6B9FA1',
  BLUE: '#1F4B99'
};

export default colorPalette;
